import React, { useState } from "react";
import dividerImg from "./images/pattern-divider-desktop.svg";
import buttonImg from "./images/icon-dice.svg";

function App() {
  return (
    <>
      <AdviceBox />
      <div className="flex justify-center">
        <h2 className="text-lightcyan absolute bottom-2 ">
          Coded by <span className="text-neongreen"> Daniel</span>
        </h2>
      </div>
    </>
  );
}

const AdviceBox = () => {
  const [advices, setAdvices] = useState(
    "It is easy to sit up and take notice, what's difficult is getting up and taking action"
  );
  const [adviceId, setadviceId] = useState(117);

  const adviceData = () => {
    fetch("https://api.adviceslip.com/advice")
      .then((response) => response.json())
      .then((data) => {
        setAdvices(data.slip.advice);
        setadviceId(data.slip.id);
      });
  };

  return (
    <div className="flex flex-col relative justify-center  items-center rounded-xl  mx-5 bg-darkgrayishblue pt-12 px-3 pb-12 max-w-md lg:max-w-[30rem]">
      <h1 className="text-neongreen text-xs font-thin tracking-[.3rem]">
        ADVICE #{adviceId}
      </h1>
      <div className="para text-center">
        <p className="text-lightcyan leading-tight text-[23px] py-6">
          {" "}
          "{advices}"
        </p>
      </div>
      <div className="img mx-8 py-4">
        <img src={dividerImg} alt="" />
      </div>

      <button
        onClick={() => adviceData()}
        className="button h-16 w-16 absolute -bottom-7 hover:shadow-[0_0_20px_10px_rgba(82,255,168,.5)] ease-in-out duration-300  bg-neongreen grid place-items-center rounded-full cursor-pointer "
      >
        <img className="w-6" src={buttonImg} alt="" />
      </button>
    </div>
  );
};
export default App;
